import {createSlice} from "@reduxjs/toolkit/react"
import {authByLoginAndPasswordAction} from "./authByLoginAndPasswordAction"
import {useSelector} from "react-redux"
import {StoreState} from "../store"

interface AuthState {
    token: string | null
    expiresAt: number | null
    username: string | null
}

const initialState: AuthState = {
    token: null,
    expiresAt: null,
    username: null
}

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state) => {
            state.token = null
            state.expiresAt = null
            state.username = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(authByLoginAndPasswordAction.fulfilled, (state, action) => {
            const {data} = action.payload
            state.token = data.access_token
            state.expiresAt = Date.now() + data.ttl * 1000
            state.username = action.meta.arg.username
        })
    }
})

export const {logout} = authSlice.actions

export default authSlice.reducer

export const useSelectedToken = () => useSelector((state: StoreState) => state.auth.token)

export const useSelectedExpiresAt = () => useSelector((state: StoreState) => state.auth.expiresAt)

export const useSelectedUsername = () => useSelector((state: StoreState) => state.auth.username)
